import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';
import { challengeService } from '@/services/challenge';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export default function () {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: null,
        name: null,
        toApp: null,
        amount: null,
        link: null,
        startTime: null,
        endTime: null,
        image: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        link: { required },
        imageFile: {},
        amount: { required, numeric, minValue: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => challengeService.get(route.params.id),
        onSuccess: ({ data }) => {
            if (data.startTime) data.startTime = new Date(data.startTime);
            if (data.endTime) data.endTime = new Date(data.endTime);
            Object.assign(model, data);
        }
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => challengeService.update(model.id, model.name, model.amount, model.link, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_CHALLENGE.INDEX })
    });

    return { v$, model, fetch, update };
}
